type Primitive = string | number | boolean | null | undefined;

export const getOverrides = <T extends Record<string, Primitive>>(
  original: T[],
  updated: T[],
  keyField: keyof T
): Record<string, Partial<T>> => {
  const result: Record<string, Partial<T>> = {};

  for (const updatedItem of updated) {
    const keyValue = updatedItem[keyField];
    const originalItem = original.find(item => item[keyField] === keyValue);
    if (!originalItem) continue;

    const diff: Partial<T> = {};

    for (const key in updatedItem) {
      if (key !== keyField && updatedItem[key] !== originalItem[key]) {
        diff[key] = updatedItem[key];
      }
    }

    if (Object.keys(diff).length > 0) {
      result[String(keyValue)] = diff;
    }
  }

  return result;
};
